import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "24",
  fill: "none",
  viewBox: "0 0 25 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#27DB55",
      d: "M8.699 5.783V3.6H2.9v16.799999999999997h5.7989999999999995v-2.183H5.04V5.783zM16.1 5.783V3.6H21.9v16.799999999999997H16.1v-2.183h3.657V5.783z"
    }, null, -1)
  ])))
}
export default { render: render }